import { GetSearchProps, type SearchOptionType, type SearchTypeToModel } from '@generated';
import { axios } from '~/util/http/axioshttp';
import { buildFilters, type SieveFilterModel } from '~/util/sieve/filter';
import { buildSortValue } from '~/util/sieve/sort';
import type { DataTableColumnProps } from '../../DataTableColumn';
import { buildExportColumns } from './exportColumns';

export interface ExportTableArgs<T extends SearchOptionType> {
	searchType: T;
	columns: DataTableColumnProps<SearchTypeToModel[T]>[];
	filters: SieveFilterModel[];
	sortColumn: string;
	sortDirection: string;
	page: number;
	pageSize: number;
	exportAll: boolean;
	fileName?: string;
}

export async function exportTable<T extends SearchOptionType>(args: ExportTableArgs<T>): Promise<void> {
	const { endpoint } = GetSearchProps(args.searchType);

	const response = await axios.post(
		`${endpoint}/export`,
		{
			filters: buildFilters(args.filters).join(','),
			sorts: buildSortValue(args.sortColumn, args.sortDirection),
			page: args.page,
			pageSize: args.pageSize,
			exportAll: args.exportAll,
			columns: buildExportColumns(args.columns),
			fileName: args.fileName
		},
		{ responseType: 'blob' }
	);

	const disposition = response.headers['content-disposition'] as string | undefined;
	const fileName = /filename\*?=(?:UTF-8'')?"?([^";]+)/i.exec(disposition ?? '')?.[1] ?? 'export.xlsx';

	const url = URL.createObjectURL(new Blob([response.data]));
	const anchor = document.createElement('a');
	anchor.href = url;
	anchor.download = decodeURIComponent(fileName);
	anchor.click();
	setTimeout(() => URL.revokeObjectURL(url), 100);
}
